const CHAVE = 'slc_destino';

// Só caminho interno. Nunca um endereço de outro site.
function seguro(p?: string | null): string | null {
  if (!p) return null;
  if (!p.startsWith('/')) return null; // bloqueia http://outro-site
  if (p.startsWith('//')) return null; // bloqueia //outro-site
  if (p.startsWith('/entrar')) return null; // não volta para o login
  return p;
}

export function guardarDestino(p?: string) {
  const destino = seguro(p ?? window.location.pathname + window.location.search);
  if (!destino) return;
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ destino, em: Date.now() }));
  } catch {
    /* navegador bloqueou: o endereço ainda salva via ?voltar= */
  }
}

export function pegarDestino(): string | null {
  // 1º) o endereço da vez  ?voltar=...
  const naUrl = seguro(new URLSearchParams(window.location.search).get('voltar'));
  if (naUrl) {
    limparDestino();
    return naUrl;
  }

  // 2º) o que foi guardado antes de sair para o Google
  try {
    const cru = localStorage.getItem(CHAVE);
    if (!cru) return null;
    const { destino, em } = JSON.parse(cru);
    limparDestino();
    // mais de 30 minutos: era de outra vez, esquece
    if (Date.now() - em > 30 * 60 * 1000) return null;
    return seguro(destino);
  } catch {
    return null;
  }
}

export function limparDestino() {
  try {
    localStorage.removeItem(CHAVE);
  } catch {
    /* ignora */
  }
}